
import kinsfolkService from "@/api/kinsfolkService";
import TeacherInfoService from "@/api/teacherService";
import teacherStore from "./teacher";

const state = {
	relationshipList: [],
	roleList: [],
};

const getters = {
	roleList: state => state.roleList,
	relationshipList: state => state.relationshipList,
};

const actions = {
	getRoleListService({ commit }, data) {
		return new Promise((resolve, reject) => {
			if (!state.roleList.length || (data && data.isForce)) {
				TeacherInfoService.getTeacherRoleListService({ school_id: teacherStore.state.teacherInfo.school_id }).then((res) => {
					commit("setRoleList", res);
					resolve(res);
				}).catch((err) => {
					reject(err);
				});
			} else {
				resolve(state.roleList)
			}

		});
	},
	getRelationShipListService({ commit }, data) {
		return new Promise((resolve, reject) => {
			if (!state.relationshipList.length || (data && data.isForce)) {
				kinsfolkService.getRelationShipListService(data).then((res) => {
					commit("setRelationshipList", res);
					resolve(res);
				}).catch((err) => {
					reject(err);
				});
			} else {
				resolve(state.relationshipList)
			}
		});
	},
};

const mutations = {
	setRelationshipList(state, relationshipList) {
		state.relationshipList = relationshipList;
	},
	setRoleList(state, roleList) {
		state.roleList = roleList;
	},
};

export default {
	actions,
	getters,
	state,
	mutations,
};
